import { of, switchMap, tap, merge } from 'rxjs';

import { replaceViewContainer, renderTemplate } from './ui.js';
import { getCollectionMetadata, getDocuments } from './knowledge-api.js';

export function createCollectionDocumentsView(colId) {
    return of(undefined).pipe(
        switchMap(() => {
            let root = renderTemplate('collection-documents-view');
            replaceViewContainer(root);

            let meta$ = getCollectionMetadata(colId);

            let renderTitle$ = meta$.pipe(
                tap(meta => {
                    root.querySelector('.collection-title').textContent = `${meta.owner}/${meta.name}`;
                }),
            );

            let documents$ = getDocuments(colId);

            let documentsContainer = root.querySelector('.documents-container');

            let renderDocuments$ = documents$.pipe(
                tap(documents => {
                    documentsContainer.innerHTML = '';
                    if (documents.length === 0) {
                        documentsContainer.textContent = 'This collection has no documents yet.';
                    } else {
                        for (let doc of documents) {
                            let docEl = renderTemplate('document-card-widget');
                            docEl.setAttribute('data-doc-id', `${doc.id}`);
                            let docLink = docEl.querySelector('.document-link');
                            docLink.textContent = doc.file_name || (doc.source_uri && `document ${doc.source_uri}`) || `document ${doc.id}`;
                            docLink.href = `#document/${doc.id}`;
                            if (doc.source_uri) {
                                let sourceUriEl = docEl.querySelector('.document-source-uri');
                                sourceUriEl.href = doc.source_uri;
                                sourceUriEl.textContent = doc.source_uri;
                                let sourceUriContainer = docEl.querySelector('.document-source-uri-container');
                                sourceUriContainer.classList.remove('hidden');
                            }
                            documentsContainer.appendChild(docEl);
                        }
                    }
                }),
            );

            return merge(
                renderTitle$,
                renderDocuments$,
            );
        }),
    );
}
